"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.object.to-string.js");
var _typeof2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/typeof.js"));
var _toConsumableArray2 = _interopRequireDefault(require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _default = exports.default = {
  methods: {
    /** 表格行KEY
     * @see getRowKey
     * @param { Object } row 行数据对象
     * @return { void }
     */
    tableRowKey: function tableRowKey(row) {
      if (this.$$isNoEmpty(this.rowOperations)) this.addRowOperations(row);
      return this.getRowKey(row);
    },
    /** 行展开触发事件
     * @description: 当用户对某一行展开或者关闭的时候会触发该事件（展开行时，回调的第二个参数为 expandedRows；树形表格时第二参数为 expanded）
     * @param { Object } row 行数据对象
     * @param { Boolean } expanded 展开状态
     * @return { void }
     */
    expandChange: function expandChange(row, expanded) {
      // console.log({ ...row }, expanded)
      this.doLayout();
      this.$$listenersEmit('expand-change', row, expanded);
    },
    /** 选择项发生变化时会触发该事件
     * @description: 当选择项发生变化时会触发该事件
     * @param { Array } selection 选中条目
     * @return { void }
     */
    selectionChange: function selectionChange(selection) {
      if (this.isSingle) {
        var a = (0, _toConsumableArray2.default)(selection).pop();
        this.tableSelection = a ? [a] : [];
      } else {
        this.tableSelection = selection;
      }
      this.$$listenersEmit.apply(this, ['selection-change'].concat(Array.prototype.slice.call(arguments)));
    },
    /** 表格行的类名定义
     * @description: 行的 className 的回调方法，也可以使用字符串为所有行设置一个固定的 className。
     * @param { Object } scope 行参数数据
     * @param { Object } scope.row 行数据
     * @param { Number } scope.rowIndex 行下标
     * @return { String } 行类名
     */
    rowClassNameCallback: function rowClassNameCallback(_ref) {
      var row = _ref.row;
      var className = "row-key-".concat(this.getRowKey(row));
      var a = this.table['row-class-name'];
      var b = this.$attrs['row-class-name'];
      if (a) className += ' ' + (0, _typeof2.default)(a) === 'function' ? a.apply(void 0, arguments) : a;
      if (b) className += ' ' + (0, _typeof2.default)(b) === 'function' ? b.apply(void 0, arguments) : b;
      return className;
    },
    /** 单元格的类名定义
     * @description: 单元格的 className 的回调方法，也可以使用字符串为所有单元格设置一个固定的 className。
     * @param { Object } scope 行参数数据
     * @param { Object } scope.row 行数据
     * @param { Object } scope.column 单元格所在列列头参数数据
     * @param { Number } scope.rowIndex 行下标
     * @return { String } 行类名
     */
    cellClassNameCal1lback: function cellClassNameCal1lback(_ref2) {
      var column = _ref2.column;
      var className = "bind-field-".concat(column.property);
      var a = this.table['cell-class-name'];
      var b = this.$attrs['cell-class-name'];
      if (a) className += ' ' + (0, _typeof2.default)(a) === 'function' ? a.apply(void 0, arguments) : a;
      if (b) className += ' ' + (0, _typeof2.default)(b) === 'function' ? b.apply(void 0, arguments) : b;
      return className;
    },
    /** 加载子节点方法
     * @description: 加载子节点数据的函数，lazy 为 true 时生效，函数第二个参数包含了节点的层级信息
     * @param { Object } row 需要挂在子数据的行数据对象
     * @param { Object } treeNode 行条目节点
     * @callback resolve 挂在子数据回调函数
     * * @param { Object[] } data 需要挂在的子数据条目
     * @return { void }
     */
    load: function load() {
      var _this = this;
      var a = Array.prototype.slice.call(arguments);
      var b = this.table.load;
      // const c = this.getTreeProps()
      var d = new Promise(function (resolve) {
        typeof b === 'function' && b(a[0], a[1], resolve);
      });
      d.then(function (res) {
        var e = [];
        if (Array.isArray(res.data)) e = res.data;else if (Array.isArray(res.row)) e = res.rows;else if (Array.isArray(res)) e = res;
        if (typeof a[2] === 'function') {
          a[2](e);
          var key = _this.getRowKey(a[0]);
          var tableTreeNode = _this.tableTreeNode[key];
          typeof tableTreeNode.resolve !== 'function' && Object.assign(tableTreeNode, {
            resolve: a[2]
          });
        }
      });
    } /* row, treeNode, resolve */
  }
};